
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/mail",
      function () {
        return require("private-next-pages/ir/mail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/mail"])
      });
    }
  